import { createContext } from "react";

export const dataContext = createContext();



// WEBPACK FOOTER //
// ./src/context/index.js